export enum RolloverStep {
  Home = 'home',
  Teachers = 'teachers',
  Students = 'students',
  DeleteClasses = 'delete_classes',
  DeleteStudents = 'delete_students',
  Finish = 'finish',
}

export const STEP_ROUTE_NAMES: Record<RolloverStep, string> = {
  [RolloverStep.Home]: 'index',
  [RolloverStep.Teachers]: 'teachers',
  [RolloverStep.Students]: 'students',
  [RolloverStep.DeleteClasses]: 'delete-classes',
  [RolloverStep.DeleteStudents]: 'delete-students',
  [RolloverStep.Finish]: 'finish',
}
